import { render, staticRenderFns } from "./teacher_detail.vue?vue&type=template&id=9f2bac30&scoped=true"
import script from "./teacher_detail.vue?vue&type=script&lang=js"
export * from "./teacher_detail.vue?vue&type=script&lang=js"
import style0 from "./teacher_detail.vue?vue&type=style&index=0&id=9f2bac30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2bac30",
  null
  
)

export default component.exports